import { customInstance } from '@/features/auth/axios-config'
import { RequestFilters, SuccessResponseResponseSearch } from '@/schema'

const API_ENDPOINT_GLOBAL_SEARCH = '/admin/v1/global-search'

export const globalSearchApi = {
  getGlobalSearch: async (data: Partial<RequestFilters>) => {
    return customInstance<SuccessResponseResponseSearch>({
      method: 'post',
      url: API_ENDPOINT_GLOBAL_SEARCH,
      data,
    })
  },
}
